import _Vue from "vue";
import {authenticator} from "@/util/authenticator";

export function Authenticator(Vue: typeof _Vue): void {
    Vue.prototype.$authenticator = authenticator;
}
